"<section> {% if page.description %} <div> {{ page.description | markdownify }} </div> {% endif %} </section>"